import { render, staticRenderFns } from "./XmAreaProvinceCity.vue?vue&type=template&id=13c12082"
import script from "./XmAreaProvinceCity.vue?vue&type=script&lang=js"
export * from "./XmAreaProvinceCity.vue?vue&type=script&lang=js"
import style0 from "./XmAreaProvinceCity.vue?vue&type=style&index=0&id=13c12082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports